import React from 'react';
import ProjectRow from './ProjectRow';

function ProjectTable({ projectList, userList }) {
  return (
    <section className="container">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Project</th>
            <th style={{ textAlign: 'center' }}>Category</th>
            <th style={{ textAlign: 'center' }}>Staff</th>
            <th style={{ textAlign: 'center' }}>Schedule</th>
            <th style={{ textAlign: 'center' }}>Sales/Cost</th>
          </tr>
        </thead>
        <tbody>
          {projectList.length > 0 ? (
            projectList.map((client) => (
              <ProjectRow key={client.client_id} client={client} userList={userList} />
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}

export default ProjectTable;
